import { OptionsApi } from '@core/swagger-client';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
    loader: async ({ context }) => {
        const myUpcomingWebinars = context.queryClient.ensureQueryData(
            OptionsApi.webinars.getMyUpcomingOrNone(context.isAuthenticated, { refetchInterval: 1000 * 60 * 1 })
        );
        const onDemand = context.queryClient.ensureQueryData(OptionsApi.webinars.getOnDemand({ refetchInterval: 60_000, staleTime: 60_000 }));
        const upcoming = context.queryClient.ensureQueryData(OptionsApi.webinars.getUpcoming({ refetchInterval: 60_000, staleTime: 60_000 }));
        await Promise.all([myUpcomingWebinars, onDemand, upcoming]);

        return {
            myUpcomingWebinars: await myUpcomingWebinars,
            onDemand: await onDemand,
            upcoming: await upcoming
        };
    }
});
